export default __webpack_public_path__ + "00d3c12cc3dfd58638d802dfb619915d.svg";